export const baseUrl = "https://api.petraconcrete.net";
export const oldBaseUrl = baseUrl;

export const AUTH_SERVICE_URL = `${baseUrl}/auth`
export const ledgerServiceUrl = `${baseUrl}/ledger`;
export const salesServiceUrl = `${baseUrl}/sales`;
export const journalServiceUrl = `${baseUrl}/journal`;
export const STOCK = `${baseUrl}/stock`;
export const SALES_SCHEDULING = `${baseUrl}/sales-scheduling`;
export const STOCK_JOURNAL = `${baseUrl}/stock-journal`;